import { render } from "./ProductElement.vue?vue&type=template&id=a1d78362&scoped=true&ts=true"
import script from "./ProductElement.vue?vue&type=script&lang=ts"
export * from "./ProductElement.vue?vue&type=script&lang=ts"

import "./ProductElement.vue?vue&type=style&index=0&id=a1d78362&scoped=true&lang=scss"

import exportComponent from "/home/christmasatourhouse-com/www/tickets/releases/202610123691/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d78362"]])

export default __exports__